import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NEWSLETTER_FORM_URL = 'http://baoliao91.cn/';

export default function Footer() {
  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      alert(t('common:footer.subscribe') + '成功！');
      form.reset();
      return;
    }
    try {
      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        alert('订阅成功！感谢您的关注！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        alert(serverMsg);
      }
    } catch {
      alert('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-2xl font-heading font-bold text-background-50 mb-6">
              {t('common:site.name')}
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {t('common:site.slogan')}
            </p>
            <p className="text-sm text-background-50/50 mt-3">
              {t('common:site.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              {t('common:footer.links')}
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                {t('common:nav.home')}
              </Link>
              <Link to="/category/911-baoliao" className="text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                911爆料
              </Link>
              <Link to="/category/51-baoliao" className="text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                51爆料
              </Link>
              <Link to="/category/91-baoliao" className="text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                91爆料
              </Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                {t('common:footer.about')}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              {t('common:footer.follow')}
            </h4>
            <div className="flex flex-col gap-3">
              <a href="http://baoliao91.cn/" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                <i className="ri-weibo-line text-base"></i>
                <span>微博</span>
              </a>
              <a href="http://baoliao91.cn/" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                <i className="ri-wechat-line text-base"></i>
                <span>微信公众号</span>
              </a>
              <a href="http://baoliao91.cn/" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 cursor-pointer whitespace-nowrap transition-colors">
                <i className="ri-tiktok-line text-base"></i>
                <span>抖音</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              {t('common:footer.newsletter')}
            </h4>
            <p className="text-sm text-background-50/60 mb-4">
              {t('common:footer.newsletterDesc')}
            </p>
            <form
              className="flex gap-2"
             
              onSubmit={handleSubmit}
            >
              <input
                type="email"
                name="email"
                required
                placeholder={t('common:footer.emailPlaceholder')}
                className="flex-1 bg-background-50/10 border border-background-50/20 rounded-md px-3 py-2 text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-background-50/50 transition-colors"
              />
              <button
                type="submit"
                className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors"
              >
                {t('common:footer.subscribe')}
              </button>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-anti-spam"
              />
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              {t('common:footer.copyright')}
            </p>
            <p className="text-xs text-background-50/30">
              {t('common:footer.disclaimer')}
            </p>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden h-20 bg-accent-950/50">
        <span className="absolute inset-0 flex items-center justify-center text-6xl md:text-8xl font-heading font-black text-background-50/[0.03] whitespace-nowrap select-none">
          {t('common:site.name')}
        </span>
      </div>
    </footer>
  );
}